import { useContext } from 'react';

import { RegistrationShipmentsContext } from '../context';
import { RegistrationShipmentsContextProps } from '../context/types';

export function useRegistrationShipments(): RegistrationShipmentsContextProps {
    return useContext(RegistrationShipmentsContext);
}
